module.exports = __webpack_public_path__ + "static/media/ipc-logo.a33a1f9d.png";